.close {
  border: var(--ns-border-width-none);
  max-width: var(--ns-width-mobile-close-sidebar);
  top: var(--ns-space-4);
  right: var(--ns-space-4);
  position: absolute;
  display: block;
  text-align: right;
  align-items: center;
  font-size: var(--ns-font-size-3);
  cursor: pointer;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  border: none;
  max-width: var(--ns-width-mobile-sidebar);
  height: 100%;
  max-height: 100%;
  animation: dialog-slide-in 0.3s ease;
}

.dialog::backdrop {
  background-color: black;
  opacity: 0.5;
  animation: backdrop-fade-in 0.3s ease;
}

@keyframes dialog-slide-in {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes backdrop-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
}

.content {
  overflow-y: auto;
  position: relative;
  background-color: var(--ns-color-white);
  height: 100%;
  margin-right: 0;
  padding: 0;
  min-width: var(--ns-width-mobile-sidebar);
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Oxygen, sans-serif;
}

/* "FILTERS" band. */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #d9d9d9;
}

.header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #555;
}

/* The grey filter menu that holds the facet sections. */
.menuArea {
  background: #ececed;
}

.facets {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Mobile-drawer-only blocks (revealed in the max-width query below). */
.mobileActive {
  display: none;
}

.mobileSpecial {
  display: none;
}

.mobileFooter {
  display: none;
}

.footerClear,
.footerApply {
  flex: 1;
  padding: 12px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  border-radius: 4px;
  cursor: pointer;
}

.footerClear {
  color: #222;
  background: #fff;
  border: 1px solid #ccc;
}

.footerApply {
  color: #fff;
  background: var(--ns-color-primary);
  border: 1px solid var(--ns-color-primary);
}

/*
 * Desktop: render the sidebar as a static left-hand column instead of a
 * modal drawer. The drawer (showModal) behaviour is kept for mobile.
 */
@media (min-width: 768px) {
  .dialog {
    position: static;
    display: block;
    width: 100%;
    max-width: none;
    height: auto;
    max-height: none;
    animation: none;
  }

  .dialog::backdrop {
    display: none;
  }

  .content {
    height: auto;
    min-width: 0;
    padding: 0;
  }

  /* No close button needed for the persistent desktop column. */
  .close {
    display: none;
  }
}

/* Mobile: drawer-specific layout — active filters inside, sticky footer. */
@media (max-width: 767px) {
  .desktopSpecial {
    display: none;
  }

  .content {
    overflow: hidden;
  }

  .mobileActive {
    display: block;
    padding: 16px 16px 0;
    background: #fff;
  }

  .mobileSpecial {
    display: block;
  }

  .menuArea {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .mobileFooter {
    display: flex;
    gap: 12px;
    padding: 16px;
    background: #fff;
    border-top: 1px solid #ddd;
  }
}
